/**
 * Event tracking constants for the Calendar page
 * Organized by sections: Week, Agenda, Action Required
 */

const FEATURE_CLICKED = 'feature_clicked' as const;
const SECTION_CLICKED = 'section_clicked' as const;
const TAB = 'calendar' as const;

/**
 * All calendar page events
 */
export const CALENDAR_EVENTS = {
  // Top-level calendar action
  APPOINTMENT_CREATED: {
    action: 'appointment_created',
    type: FEATURE_CLICKED,
    tab: TAB,
  },
  // Print the current view; fired with section/source_tab, row_count and truncated
  PRINTED: {
    action: 'connect_calendar_print',
    type: FEATURE_CLICKED,
    tab: TAB,
  },

  // Week View Section
  WEEK: {
    SECTION_CLICKED: {
      action: 'section_clicked',
      type: SECTION_CLICKED,
      tab: TAB,
      section: 'week',
    },
    FILTER_SELECTED: {
      action: 'filter_selected',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'week',
    },
    SEARCHED: {
      action: 'searched',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'week',
    },
  },

  // Agenda View Section
  AGENDA: {
    SECTION_CLICKED: {
      action: 'section_clicked',
      type: SECTION_CLICKED,
      tab: TAB,
      section: 'agenda',
    },
    FILTER_SELECTED: {
      action: 'filter_selected',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'agenda',
    },
    SEARCHED: {
      action: 'searched',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'agenda',
    },
  },

  // Action Required (Overdue) View Section
  ACTION_REQUIRED: {
    SECTION_CLICKED: {
      action: 'section_clicked',
      type: SECTION_CLICKED,
      tab: TAB,
      section: 'action_required',
    },
    FILTER_SELECTED: {
      action: 'filter_selected',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'action_required',
    },
    SEARCHED: {
      action: 'searched',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'action_required',
    },
  },
} as const;
